const TAXATION_STATUS = {
  Taxable: "課税",
  TaxExempt: "非課税",
} as const;

export const isTaxExempt = (value: string): boolean => {
  return value === TAXATION_STATUS.TaxExempt;
};
